(ns manatee.qa.app-db)

(def qa-root [:qa])
(def submission-type-path (conj qa-root :submission-type))
(def edit-path (conj qa-root :edit))
(def comparate-edits-path (conj qa-root :comparate-edits))
(def comparate-item-groups-path (conj qa-root :comparate-item-group))
(def item-group-path (conj qa-root :item-group))
(def item-path (conj qa-root :item))
(def qa-loading-path (conj qa-root :loading))
(def aihyb-filter-path (conj qa-root :aihyb-filter))

(defn set-submission-type
  [db submission-type]
  (assoc-in db submission-type-path submission-type))

(defn get-submission-type
  [db]
  (get-in db submission-type-path))

(defn set-viewed-items
  [db items]
  (update db :viewed-items #(set (concat % items))))

(defn get-edit
  [db]
  (get-in db edit-path))

(defn set-edit
  [db edit]
  (assoc-in db edit-path edit))

(defn get-comparate-edits
  [db]
  (get-in db comparate-edits-path))

(defn set-comparate-edits
  [db edits]
  (assoc-in db comparate-edits-path edits))

(defn set-comparate-item-group
  [db which-user item-group]
  (assoc-in db (conj comparate-item-groups-path which-user) item-group))

(defn get-comparate-item-groups
  [db]
  (get-in db comparate-item-groups-path))

(defn clear-comparate-item-groups
  [db]
  (dissoc db comparate-item-groups-path))

(defn get-edit-user-id
  [db]
  (get-in db (conj edit-path :user-id)))

(defn clear-edit
  [db]
  (update-in db qa-root dissoc :edit))

(defn get-item
  [db]
  (get-in db item-path))

(defn set-item
  [db item]
  (assoc-in db item-path item))

(defn clear-item
  [db]
  (update-in db qa-root dissoc :item))

(defn get-item-group
  [db]
  (get-in db item-group-path))

(defn set-item-group
  [db item-group]
  (assoc-in db item-group-path item-group))

(defn clear-item-group
  [db]
  (update-in db qa-root dissoc :item-group))

(defn set-qa-loading
  [db loading?]
  (assoc-in db qa-loading-path loading?))

(defn get-qa-loading
  [db]
  (get-in db qa-loading-path))

(defn get-aihyb-filter
  [db]
  (get-in db aihyb-filter-path))

(defn set-aihyb-filter
  [db filter]
  (assoc-in db aihyb-filter-path filter))
